export enum AnimatedRoundedSelectSize {
  ExtraSmall = "XS",
  Small = "S",
  Medium = "M",
  ExternalLayoutStandard = "ExternalLayout",
}
